import {
    BasicEmployeeView,
    CreateEmployeeRequestDTO,
    EmployeeOverviewView,
    SortableEmployeeField,
    UpdateEmployeeRequestDTO
} from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';
import { SMART_EMPLOYEE_OVERVIEW_FILTER } from 'src/app/shared/constants-and-enums/smart-employee-overview-types';

export const CompanyEmployeeActionFailure = createAction(
    '[CompanyEmployee] CompanyEmployeeActionFailure',
    props<{
        error: any;
    }>()
);

export const CreateCompanyEmployee = createAction(
    '[CompanyEmployee] CreateCompanyEmployee',
    props<{ request: CreateEmployeeRequestDTO }>()
);
export const CreateCompanyEmployeeSuccess = createAction(
    '[CompanyEmployee] CreateCompanyEmployeeSuccess',
    props<{ employee: BasicEmployeeView }>()
);

export const UpdateCompanyEmployee = createAction(
    '[CompanyEmployee] UpdateCompanyEmployee',
    props<{ companyEmployeeId: string; request: UpdateEmployeeRequestDTO; companyId: string }>()
);
export const UpdateCompanyEmployeeSuccess = createAction(
    '[CompanyEmployee] UpdateCompanyEmployeeSuccess',
    props<{ employee: BasicEmployeeView }>()
);

export const DeleteCompanyEmployee = createAction(
    '[CompanyEmployee] DeleteCompanyEmployee',
    props<{ companyEmployeeId: string; companyId: string }>()
);
export const DeleteCompanyEmployeeSuccess = createAction(
    '[CompanyEmployee] DeleteCompanyEmployeeSuccess',
    props<{ companyEmployeeId: string; companyId: string }>()
);

export const LoadCompanyEmployeeDetailsByCompany = createAction(
    '[CompanyEmployee] LoadCompanyEmployeeDetailsByCompany',
    props<{ companyId: string }>()
);
export const LoadCompanyEmployeeDetailsSuccess = createAction(
    '[CompanyEmployee] LoadCompanyEmployeeDetailsSuccess',
    props<{ employees: EmployeeOverviewView[]; companyId: string }>()
);
export const LoadCompanyEmployeeDetailsFailure = createAction(
    '[CompanyEmployee] LoadCompanyEmployeeDetailsFailure',
    props<{ error: any }>()
);

export interface CompanyEmployeeOverviewPageParams {
    companyId: string;
    pageIndex: number;
    pageSize: number;
    officeIds?: string[];
    employeeGroups?: string[];
    searchQuery?: string;
    filter?: SMART_EMPLOYEE_OVERVIEW_FILTER;
    sortField?: SortableEmployeeField;
    sortAscending?: boolean;
}

export const LoadCompanyEmployeeOverviewPage = createAction(
    '[CompanyEmployee] LoadCompanyEmployeeOverviewPage',
    props<{ params: CompanyEmployeeOverviewPageParams }>()
);

export const LoadCompanyEmployeeOverviewPageSuccess = createAction(
    '[CompanyEmployee] LoadCompanyEmployeeOverviewPageSuccess',
    props<{
        employees: EmployeeOverviewView[];
        totalElements: number;
        pageIndex: number;
        pageSize: number;
        companyId: string;
    }>()
);

export const LoadCompanyEmployeeOverviewPageFailure = createAction(
    '[CompanyEmployee] LoadCompanyEmployeeOverviewPageFailure',
    props<{ error: any }>()
);

export const LoadEmployeeFilterCounts = createAction('[CompanyEmployee] LoadEmployeeFilterCounts', props<{ companyId: string }>());

export interface EmployeeFilterCounts {
    all: number;
    registered: number;
    notRegistered: number;
    former: number;
}

export const LoadEmployeeFilterCountsSuccess = createAction(
    '[CompanyEmployee] LoadEmployeeFilterCountsSuccess',
    props<{ counts: EmployeeFilterCounts }>()
);

export const LoadEmployeeFilterCountsFailure = createAction('[CompanyEmployee] LoadEmployeeFilterCountsFailure', props<{ error: any }>());
